'use strict';

/**
 * expects miliseconds and display them in format HH:mm:ss
 */
customerZone.filter('msToHMS', function () {
    return function(ms) {
        // return default value if input can't be evaluated to a number
        if ( isNaN(ms) )
            return '0:00:00';
        // convert string to number
        if ( typeof ms === 'string')
            ms = parseInt(ms, 10);
        // 1- Convert to seconds:
        var seconds = ms / 1000;
        // 2- Extract hours:
        var hours = Math.floor(seconds / 3600); // 3,600 seconds in 1 hour
        seconds = seconds % 3600; // seconds remaining after extracting hours
        // 3- Extract minutes:
        var minutes = Math.floor(seconds / 60); // 60 seconds in 1 minute
        // 4- Keep only seconds not extracted to minutes:
        seconds = Math.round(seconds % 60);

        function twoDigits(number) {
            return ('0' + number).slice(-2);
        }

        return ( hours + ':' + twoDigits(minutes) + ':' + twoDigits(seconds));
    };
});
